/* eslint-disable import/no-unresolved */
export { unstable_batchedUpdates } from 'react-dom';


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-redux/es/utils/reactBatchedUpdates.js
// module id = QOR+
// module chunks = 1